__turbopack_context__.v({
  "answer": "FAQ-module__PeunLG__answer",
  "faqContainer": "FAQ-module__PeunLG__faqContainer",
  "faqItem": "FAQ-module__PeunLG__faqItem",
  "faqItems": "FAQ-module__PeunLG__faqItems",
  "header": "FAQ-module__PeunLG__header",
  "icon": "FAQ-module__PeunLG__icon",
  "open": "FAQ-module__PeunLG__open",
  "question": "FAQ-module__PeunLG__question",
  "subtitle": "FAQ-module__PeunLG__subtitle",
  "tag": "FAQ-module__PeunLG__tag",
});
